import { gql } from '@apollo/client';
import { CORE_PLAYLIST_FIELDS } from './fragments';

export const listPlaylists = gql`
  ${CORE_PLAYLIST_FIELDS}
  query listPlaylists($filter: PlaylistFilter, $pagination: PaginationInput) {
    listPlaylists(filter: $filter, pagination: $pagination) {
      ...CorePlaylistFields
    }
  }
`;

export const listMembers = gql`
  query listMembers($pagination: PaginationInput, $filter: MemberFilter) {
    listMembers(pagination: $pagination, filter: $filter) {
      id
      user {
        id
        email
        name
      }
    }
  }
`;
